<template>
  <div
    class="px-1"
    style="position: relative; margin: 0 auto"
    @keyup.enter="loginJWT"
  >
    <p v-if="!isBis" class="text-primary bold text-center mb-1 h3">Kullanıcı Paneli</p>
    <p v-else class="text-primary bold text-center mb-1 h3">Brew Mood İletişim Sistemi</p>
    <vs-input
      v-validate="'required|min:3'"
      data-vv-validate-on="blur"
      name="Kullanıcı Adı"
      icon-no-border
      icon="icon icon-user"
      icon-pack="feather"
      size="large"
      placeholder="Kullanıcı Adı"
      v-model="email"
      class="pt-6 login-input-bg"
    />
    <span class="text-danger text-sm">{{ errors.first("Kullanıcı Adı") }}</span>

    <vs-input
      data-vv-validate-on="blur"
      v-validate="'required|min:2|max:10'"
      type="password"
      name="Şifre"
      icon-no-border
      icon="icon-lock"
      icon-pack="feather"
      placeholder="Şifre"
      v-model="password"
      class="login-input-bg pt-6"
      size="large"
    />
    <span class="text-danger text-sm">{{ errors.first("Şifre") }}</span>
    <div class="flex flex-wrap justify-between my-4">
      <router-link
        to="/pages/forgot-password"
        style="font-size: 0.9rem !important"
        >Şifreni mi unuttun?</router-link
      >
    </div>
    <vs-button
      class="bg-success text-light sale-box-shadow login-btn"
      size="large"
      color="transparent"
      @click="loginJWT"
      >GİRİŞ
    </vs-button>
  </div>
</template>

<script>
import jwt from "@/http/requests/auth/jwt/index.js";
export default {
  props: {
      isBis: {
        type: Boolean,
        required: true
      },
      isDocument: {
        type: Boolean,
        required: true
      }
    },
  data() {
    return {
      email: null,
      password: null,
      checkbox_remember_me: false,
    };
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.email != null && this.password != null;
    },
  },
  methods: {
    checkLogin() {
      return true;
    },
    loginJWT() {
      if (!this.validateForm) return;
      //if (!this.checkLogin()) return

      // Loading

      /*const payload = {
          checkbox_remember_me: this.checkbox_remember_me,
          userDetails: {
            email: this.email,
            password: this.password
          }
        }*/
      jwt
        .login(this.email, this.password)
        .then((res) => {
          if (res && res.data.result) {
            console.log(this.isBis);
            localStorage.setItem("isBis",this.isBis);
            localStorage.setItem("isDocument",this.isDocument);
            this.$store.dispatch("auth/loginJWT", res.data.data);
          } else {
            const code =
              res.data.errors &&
              res.data.errors[0] &&
              res.data.errors[0].message;
            let text = "Kullanıcı Adı ve Şifre Uyuşmuyor";
            if (code === "BRANCH_NOT_ACTIVE") {
              text =
                "Şubeniz pasif olduğu için giriş yapılamıyor. Yöneticinizle iletişime geçin.";
            } else if (code === "USER_NOT_ACTIVE") {
              text = "Kullanıcı hesabınız pasif.";
            }
            this.$vs.notify({
              title: "Hatalı Giriş !",
              text,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });
    },
    registerUser() {
      if (!this.checkLogin()) return;
      this.$router.push("/pages/register").catch(() => {});
    },
  },
};
</script>

<style>
.vx-col {
  background-color: transparent;
}

.login-input-bg div input {
  background: #d3d3d3 !important;
  border: none !important;
  border-radius: 1rem;
  box-shadow: 2px 3px 6px rgba(0, 0, 0, 0.4);
  width: 100%;
  min-width: 300px;
  padding: 12px;
  box-sizing: border-box;
  resize: vertical;
}

.login-btn {
  border-radius: 1rem;
  width: 100%;
  min-width: 300px;
  padding: 12px;
  box-sizing: border-box;
}
</style>
